.container {
  border-radius: 4px;
  border: 1px solid var(--default--border-color--10);
}
